/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import { Button } from "@mui/material";
import FileUploadSharpIcon from "@mui/icons-material/FileUploadSharp";
import ERPUtils from "./Utils";
import { Visibility } from "@mui/icons-material";
import UploadViewPopup from "./UploadViewPopup";
import "./UploadComponent.css";
import ApiGateway from "./ApiGateway";
import { toast } from "react-toastify";
// import AppContext from "./AppContext";

export default function UploadFile(props) {

  // data
  // callback mathod
  // type- single or multi
  // tabid-props.context.getTabID()
  // accept formats -
  // isViewOnly
  const [isMulti, setIsMulti] = useState(props?.isMulti || false);
  const [data, setData] = useState(props?.data || []);
  const [fileType, setFileType] = useState("all");
  const [isView, setIsview] = useState(false);
  const [accept, setAccept] = useState(props?.accept || "all");
  const [uniqueId, setUniqueId] = useState(Math.floor(100000 + Math.random() * 900000));
  const [popupData, setPopupData] = useState([props?.data || []]);
  const [loading, setLoading] = useState(false);
  const [labelText, setLabelText] = useState("Upload & View");
  const [isSubmitButton, setSubmitButton] = useState(false);

  const getKeyPathFromList = (list) => {
    const key = props?.id;
    for (let index = 0; index < list?.length; index++) {
      if (list[index]?.uploadProcessCode === key) {
        return {
          tempPath: list[index]?.tempFolderPath,
          actualPath: list[index]?.folderPath,
          folderListId: list[index]?.folderListId,
          fileSizeInKB: list[index]?.fileSizeInKB,
          fileTypeList: list[index]?.fileTypeList,
          uploadProcessCode: list[index]?.uploadProcessCode,
        };
      }
    }
    return null;
  };

  //method for checking passport size 
  
  const ACCEPTED_FORMATS = ['image/jpeg', 'image/png'];
  // Define the maximum and minimum dimensions of the photo
  const max_width = 35; // in mm
  const max_height = 45; // in mm
  const min_width = 33; // in mm
  const min_height = 43; // in mm

  // Define the maximum file size of the photo
  const max_size = 300 * 1024; // in bytes
  

  const dpi = 300; // for a standard passport size photo
  function isPassportSizeImage(event) {

    let file = event.target.files[0];
    if (!ACCEPTED_FORMATS.includes(file?.type)) {
      // Check if file is in accepted formats
      props.errorCallBack("Only JPEG and PNG images accepted");
    }
    if (file.size > max_size) {

      props.errorCallBack("The file size is too large. Please upload a photo with a file size less than 300KB.");
    }
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        const width = this.width;
        const height = this.height;
        const mm_width = (width / dpi) * 25.4;
        const mm_height = (height / dpi) * 25.4;
        // Check if the dimensions are within the allowed range
        if (mm_width < min_width || mm_height < min_height || mm_width > max_width || mm_height > max_height) {
          props.errorCallBack("The dimensions of the photo should be 35x45mm.");
        } else {
          fileUpload(event)
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
    // return isValid;
  }

  // method for calling when file are browsed
 
  
  const checkDuplicateFileName = (name) => {
    const newState =ERPUtils.isUndefinedOrNull(popupData)?[]:[...popupData]
    let diffrentFormat =""
    for (let index = 0; index < newState?.length; index++) {
      const fileName = newState[index]?.originalFileName?.split(".")[0];
      if(ERPUtils.isUndefinedOrNull(fileName)){
         diffrentFormat = newState[index]?.name?.split(".")[0];
      }

      if (fileName === name || diffrentFormat === name) {
        //toast.warn( "A file already exist with same name" );
        return true;
      }
     
    }
    return false;
  };
  const fileUpload = async (event) => {
    setSubmitButton(true);
    let fileValue = !ERPUtils.isNullorWhiteSpace(popupData) && ERPUtils.isArray(popupData) ? [...popupData ]: [];
    let isInvalidFile = false;
    if (!ERPUtils.isUndefinedOrNull(event.target.files?.length > 0)) {
      Object.keys(event.target.files).forEach((e) => {
        const { name } = event.target.files[e];
        const size = event.target.files[e].size / 1000;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const extension = name.substring(lastDot + 1);
        const file = event.target.files[e];
        // validating the file name length
       

        if (checkDuplicateFileName(fileName) === false) {
          if (String(name).length <= 100) {
            const extensionList = !ERPUtils.isNullorWhiteSpace(getKeyPathFromList(props.keyList)?.fileTypeList) ? getKeyPathFromList(props.keyList)?.fileTypeList : null;
            if (!ERPUtils.isNullorWhiteSpace(extensionList)) {
              if (Array.isArray(extensionList)) {
                // validating the extensions
                if (extensionList.includes(String(`.${extension}`).toLowerCase())) {
                  const fileSize = parseFloat(getKeyPathFromList(props.keyList)?.fileSizeInKB || 1);
                  // validating the file size in kb
                  if (parseFloat(size) <= fileSize) {
                    const fileNameObj = {
                      file, name: `${fileName}.${extension}`, extension,
                    };
                    if (!isMulti) {
                      fileValue = [];
                      fileValue.push(fileNameObj);
                    } else {
                      fileValue.push(fileNameObj);
                    }
                  } else {
                    isInvalidFile = true;
                    toast.warn( `File size must be less than ${fileSize}kb`);
                  }
                } else {
                  isInvalidFile = true;
                  toast.warn("Invalid file extension." );
                }
              }
            } else {
              isInvalidFile = true;
              toast.warn( "Uploading files failed" );
            }
          } else {
            isInvalidFile = true;
            toast.warn("Please rename the files name. (Name length should be less than or equal to 100 characters)");
          }
        } else {
          toast.warn( "A file already exist with same name" );
        }
      }
  
      );
      if (!isInvalidFile) {
        await setPopupData(fileValue);
        await setIsview(true);
      }

    }
  };
  const closePopup = () => {
    setIsview(false);
    setPopupData(data);
  };


  const submitData = (dataList, isFromDelete,filesMeta) => {
    const otherParams=props?.otherParams
    props?.callback(dataList,otherParams,filesMeta);
    if (!isFromDelete) {
      closePopup();
    }
  };

  // this method is called when the user browse and chooses all the files and click submit in the popup

  const generateURLAndSubmit = async () => {
    const isMulti = props?.isMulti === true;

    let fileValue = !ERPUtils.isNullorWhiteSpace(popupData) && ERPUtils.isArray(popupData) ?popupData : [];
   
    let dataList = !ERPUtils.isNullorWhiteSpace(data) && ERPUtils.isArray(data) ? data : [];
    
    if (!isMulti && fileValue?.length > 0) {
          fileValue = [fileValue[fileValue?.length - 1]]; 
          dataList = []; 
        }

    const UploadFileArray = [];
    const fileNameArray = [];
    let isFileForSaving = false;
    setLoading(true);
    const pathKey = getKeyPathFromList(props?.keyList || []);
    const processCode = getKeyPathFromList(props?.keyList || []);
    if (!ERPUtils.isNullorWhiteSpace(pathKey)) {
      for (let index = 0; index < fileValue.length; index++) {
        // checking for new files to be saved
        if (typeof fileValue[index] === "object" && !ERPUtils.isNullorWhiteSpace(fileValue[index]?.file)) {
          const presignedURLObj = {
            originalFileName: `${fileValue[index]?.name}`,
            tempPath: null,
            actualPath: null,
            // tempPath: pathKey?.tempPath,
            // actualPath: pathKey?.actualPath,
            preSignedUrl: "",
            processCode: processCode?.uploadProcessCode,
            uniqueFileName: "",
            id: "",
          };
          UploadFileArray.push(presignedURLObj);
          const fileNameObj = {
            file: fileValue[index]?.file, name: `${fileValue[index]?.name}`,
          };
          fileNameArray.push(fileNameObj);
          isFileForSaving = true;
        }
      }
      if (isFileForSaving) {
        ERPUtils.loading(props.tabId, true);
        // if new files, requesting for the presigned url
        await ApiGateway.post("fileUploadDownLoad/upload/presigned", UploadFileArray, async (response) => {
          const responseObj = !ERPUtils.isUndefinedOrNull(response?.data)? response.data : []
          if (!ERPUtils.isNullorWhiteSpace(responseObj)) {
            const isSavingDone = [];
            for (let index = 0; index < responseObj.length; index++) {
              for (let fileIndex = 0; fileIndex < fileNameArray.length; fileIndex++) {
                if (fileNameArray[fileIndex].name === responseObj[index].originalFileName) {
                  const myNewFile = new File([fileNameArray[fileIndex].file], responseObj[index]?.uniqueFileName, { type: fileNameArray[fileIndex].file.type });
                  // the file is submitted to the received presigned url
                  // eslint-disable-next-line no-await-in-loop
                  await axios.put(responseObj[index].preSignedUrl, myNewFile, {
                    headers: {
                      "Content-type": "multipart/form-data",
                    },
                  }).then((res) => {
                    const filePath = `${responseObj[index]?.tempPath}${responseObj[index]?.uniqueFileName}`;
                    const keyObj = getKeyPathFromList(props?.keyList || []);
                    const obj = {
                      originalFileName: responseObj[index]?.originalFileName,
                      uniqueFileName: responseObj[index]?.uniqueFileName,
                      // tempPath: filePath,
                      tempPath: null,
                      newFile: true,
                      id: "",
                      processCode: processCode?.uploadProcessCode,
                      // actualPath: responseObj[index]?.actualPath,
                      actualPath: null,
                      // here the orginal file itself is attached to show the item from local until screen submit
                      preSignedUrl: fileNameArray[fileIndex].file,
                      folderListId: !ERPUtils.isNullorWhiteSpace(keyObj) ? keyObj?.folderListId : "",
                    };

                    if (ERPUtils.isArray(fileValue)) {
                      dataList.push(obj);
                      isSavingDone.push(filePath);
                    }
                  })
                    .catch((err) => {
                      toast.warn(`Uploading ${fileNameArray[fileIndex].file?.name || "a"} file failed` );
                    });
                }
              }
            }
            if (isSavingDone.length === UploadFileArray.length) {
              await submitData(dataList, false,fileValue);
              await setPopupData(dataList);
            }
          } else {
            toast.warn( "Sorry, Uploading Failed" );
          }
          ERPUtils.loading(props.tabId, false);
        });
      } else {
        await submitData(dataList, false,fileValue);
        await setPopupData(dataList);
      }
    } else {
      toast.warn( "Sorry, Uploading Failed" );
      ERPUtils.loading(props.tabId, false);
    }
    setSubmitButton(false);
  };

  const openUploadWindow = () => {
    $(`#fileUpload_input${uniqueId}`).trigger("click");
  };

  const showPreviewPopup = (datas) => {
    if (datas?.length > 0) {
      setIsview(true);
    }else if (datas?.length === 0 && props?.isViewOnly) {
      setIsview(false);
      toast.warn( "No file available" );
    } else {
      setIsview(false);
      openUploadWindow();
    }
  };

  const deleteFileMethod = (fileName, id) => {
    // const dataArray = ERPUtils.cloneState(popupData);
    const dataArray =[...popupData]
    dataArray.splice(id, 1);
    $(`#fileUpload_input${uniqueId}`);
    document.getElementById(`fileUpload_input${uniqueId}`).value = "";
    setPopupData(dataArray);
    setData(dataArray);
    submitData(dataArray, true);
  };

  useEffect(() => {
    setData(props.data);
    setPopupData(props.data);
    if (!ERPUtils.isNullorWhiteSpace(props?.label)) {
      setLabelText(props.label);
    }
  }, [props.data, props.label]);

  return (
    <span className="text-primary">
      <span className="text-primary font-weight-bold mr-2">
        <input
          type="file"
          id={`fileUpload_input${uniqueId}`}
          style={{ display: "none" }}
          onChange={props.checkPassportSize ? isPassportSizeImage : fileUpload}
          multiple={!!isMulti}
          accept={getKeyPathFromList(props.keyList)?.fileTypeList || ""}
          disabled={props?.disabled}
        />
        {/* <label className="text-primary uploadLabel">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<FileUploadSharpIcon />}
            onClick={() => showPreviewPopup(data, true)}
          >
            {labelText}
            &nbsp;
            {popupData?.length > 0 ? `(${data?.length})` : ""}
          </Button>
        </label> */}
        <label className="uploadLabel">
          {props?.isViewOnly === true || props?.isViewOnly === "true" ? (
            <Visibility role="button" onClick={() => showPreviewPopup(data, true)} style={{cursor:"pointer"}}/>
          )
            : props?.isIconButton === true ? (
              <span
                style={{ color: "var(--uploadComponentColor)" }}
                role="button"
                onKeyDown={() => showPreviewPopup(data, true)}
                tabIndex={0}
                onClick={() => showPreviewPopup(data, true)}
              >
                {data?.length > 0 ? <Visibility /> : <FileUploadSharpIcon />}
                {data?.length > 0 ? " View File" : "Upload File"}
              </span>
            )
              : (
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<FileUploadSharpIcon />}
                  onClick={() => showPreviewPopup(data, true)}
                >
                  {labelText}
            &nbsp;
                  {data?.length > 0 ? `(${data?.length})` : ""}
                </Button>
              )}
        </label>
        {" "}
      </span>
      {isView
        ? (
          <UploadViewPopup
            onChange={fileUpload}
            data={popupData}
            isMulti={isMulti}
            fileType={fileType}
            closePopup={closePopup}
            onDelete={deleteFileMethod}
            openUploadWindow={openUploadWindow}
            submitData={generateURLAndSubmit}
            loading={loading}
            isSubmitButton={isSubmitButton}
            tabId={props?.tabId}
            processKey={getKeyPathFromList(props?.keyList || [])?.uploadProcessCode}
            isViewOnly={props?.isViewOnly}
          />
        )
        : null}
    </span>
  );
}
